import React from 'react';

import ProjectPageLayout from '@adsk/alloy-project-page-layout';
import { PRODUCT_IDS } from '@adsk/alloy-provider';

import RemoteSideNavigation from '../../../components/RemoteSideNavigation/RemoteSideNavigation';

export const ACCOUNT_ADMIN_LAYOUT_PROPS = {
  currentProductId: PRODUCT_IDS.ACCOUNT_ADMINISTRATION,
  variant: ProjectPageLayout.VARIANTS.ACCOUNT,
  isUsersConstructionApi: true,
  renderSideNavigation: (props: typeof RemoteSideNavigation) => (
    <RemoteSideNavigation
      scope="accAdminClient"
      moduleName="./AccountSideNavigation"
      {...props}
    />
  ),
};

export const ACCOUNT_ADMIN_NO_SIDE_NAVIGATION_LAYOUT_PROPS = {
  currentProductId: PRODUCT_IDS.ACCOUNT_ADMINISTRATION,
  variant: ProjectPageLayout.VARIANTS.ACCOUNT,
  isUsersConstructionApi: true,
  renderSideNavigation: () => null,
};
